import React from 'react';
import PropTypes from 'prop-types';
import {InlineMessage} from '@homeaway/react-alerts';

import {useComponent} from './hooks/useComponent';

function SearchDestinationErrorMessage({message}) {
    const {showDestinationErrorMessage} = useComponent();

    return (
        <>
            <InlineMessage id="searchform-destination-error" type="danger" message={showDestinationErrorMessage && message} marginTop={8}/>
        </>
    );
}

SearchDestinationErrorMessage.propTypes = {
    message: PropTypes.string,
};

export {SearchDestinationErrorMessage};